module.exports = __webpack_public_path__ + "static/media/2.44a5ee42.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/九宫格选中态/2.png
// module id = 950
// module chunks = 0